import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function PageTitle({i18n}) {

    const location = useLocation();

    useEffect(() => {
        switch (location.pathname) {
            case i18n.SubNav_About_Link:
                document.title = i18n.About_Page_Title;
                break;
            case i18n.SubNav_Summary_Link:
                document.title = i18n.Summary_Page_Title;
                break;
            case i18n.SubNav_Details_Link:
                document.title = i18n.Details_Page_Title;
                break;
            default:
                document.title = i18n.Default_Page_Title;
        }
    }, [location.pathname]);

    return null;
}